<!--侧边栏界面-->

<!--        会直接按照下方index的路径进行跳转-->
<!--       router 根据index不同改变页面-->
<template>

</template>

<script>
import router from '@/router/index.js'

// const request = require("@/utils/request");

export default {
  name: "Aside",
  data() {
    return {
      //这里一定要设置user变量
      user: {},
      //设置默认高光的菜单
      path: this.$route.path
    }
  },

  //控制因身份不同而改变样式的侧边栏
  created() {
    //从缓存中获取信息
    let userStr = sessionStorage.getItem("user") || "{}"
    //从网页中获取到JSON串之后转化成user对象，基于user对象然后进行判断
    this.user = JSON.parse(userStr)

    // // 请求服务端，确认当前登录用户的 合法信息
    // // 因为在浏览器可以自行修改，因此需要向服务端请求数据而不是在浏览器拿到数据
    // //这段代码可以通过id拿到当前页面最新的数据信息，然后赋值给浏览器中的data，作为校验的作用
    // request.get("/user/" + this.user.id).then(res => {
    //   if (res.code === '0') {
    //     this.user = res.data
    //   }
    // })
  }
}
</script>

<style scoped>

</style>
